<template>
  <div
    class="editor-wrapper"
  >
    <tiptap-vuetify
      v-model="computedContent"
      :extensions="extensions"
    />
  </div>
</template>

<script>

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify';

export default {
  name: 'EditorSimple',
  components: { TiptapVuetify },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        [Link, {
          options: {
            target: '_blank',
          },
        }],
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3],
          },
        }],
        Bold,
        HorizontalRule,
        HardBreak,
      ],
    };
  },
  computed: {
    computedContent: {
      get() {
        return this.content;
      },
      set(val) {
        this.$emit('update:content', val);
      },
    },
  },
};

</script>
<style>
.tiptap-vuetify-editor__content
{
  min-height: 300px;
}
.tiptap-vuetify-editor .ProseMirror {
  min-height: 300px;
}
</style>
